import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_installments_plan = _resolveComponent("installments-plan")
  const _component_installments_description_box = _resolveComponent("installments-description-box")

  return (_openBlock(), _createBlock(_component_installments_description_box, {
    "number-of-installments": $options.numberOfInstallments,
    "is-notificator-visible": $options.isNotificatorVisible
  }, {
    content: _withCtx(() => [
      _createVNode(_component_installments_plan, _normalizeProps(_guardReactiveProps($options.installmentsPlanData)), null, 16 /* FULL_PROPS */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["number-of-installments", "is-notificator-visible"]))
}